import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-header-for-open-pages',
  templateUrl: './header-for-open-pages.component.html',
  styleUrls: ['./header-for-open-pages.component.css']
})
export class HeaderForOpenPagesComponent implements OnInit {

  path: string;

  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {

    if(this.route.snapshot.url.length > 0){

      this.path = this.route.snapshot.url[0].path;
    }
  }

}
